export const getStyle = (style, theme, ...args) => (typeof style === 'function' ? style(theme, ...args) : style);
